import styled from "styled-components";
import Link from "antd/es/typography/Link";
const isMobile = window.innerWidth < 768;

export const StyledAuth = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 50px;
    padding-top: ${isMobile ? '90px'  : '160px' };
    background-color: rgba(251, 247, 240, 1);
`

export const StyledLink = styled(Link)`
  font-size: 20px;
  line-height: 32px;
`;